/* unplugin-vue-components disabled */import script from "./panel-company.vue?vue&type=script&setup=true&lang=ts"
export * from "./panel-company.vue?vue&type=script&setup=true&lang=ts"

import "./panel-company.vue?vue&type=style&index=0&id=49677d43&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49677d43"]])

export default __exports__